'use strict';
var FIX_GCAPTCHA_LABEL = (function () {
    var waitForElm = function (selector) {
        return new Promise(function (resolve) {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            var observer = new MutationObserver(function (_mutations) {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };
    var init = function () {
        waitForElm('.g-recaptcha-response').then(function (_) {
            var gCaptcha = document.querySelector(".g-recaptcha-response");
            if (gCaptcha) {
                gCaptcha.setAttribute("aria-hidden", "true");
                gCaptcha.setAttribute("aria-label", "internal Google Captcha hiddem field");
                gCaptcha.setAttribute("aria-readonly", "true");
            }
        });
    };
    return {
        'init': init
    };
})();
export { FIX_GCAPTCHA_LABEL };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZml4R0NhcHRjaGFMYWJlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL25vZGUvdHMvY2xhc3Nlcy9maXhHQ2FwdGNoYUxhYmVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFlBQVksQ0FBQztBQUliLElBQU0sa0JBQWtCLEdBQUcsQ0FBQztJQVd4QixJQUFNLFVBQVUsR0FBRyxVQUFDLFFBQWdCO1FBQ2hDLE9BQU8sSUFBSSxPQUFPLENBQUMsVUFBQSxPQUFPO1lBQ3RCLElBQUksUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsRUFBRTtnQkFDbEMsT0FBTyxPQUFPLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO2FBQ3BEO1lBRUQsSUFBTSxRQUFRLEdBQUcsSUFBSSxnQkFBZ0IsQ0FBQyxVQUFBLFVBQVU7Z0JBQzVDLElBQUksUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsRUFBRTtvQkFDbEMsUUFBUSxDQUFDLFVBQVUsRUFBRSxDQUFDO29CQUN0QixPQUFPLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO2lCQUM3QztZQUNMLENBQUMsQ0FBQyxDQUFDO1lBRUgsUUFBUSxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsSUFBSSxFQUFFO2dCQUM1QixTQUFTLEVBQUUsSUFBSTtnQkFDZixPQUFPLEVBQUUsSUFBSTthQUNoQixDQUFDLENBQUM7UUFDUCxDQUFDLENBQUMsQ0FBQztJQUNQLENBQUMsQ0FBQTtJQUVELElBQU0sSUFBSSxHQUFHO1FBRVQsVUFBVSxDQUFDLHVCQUF1QixDQUFDLENBQUMsSUFBSSxDQUFDLFVBQUMsQ0FBQztZQUN2QyxJQUFNLFFBQVEsR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLHVCQUF1QixDQUFDLENBQUM7WUFFakUsSUFBSSxRQUFRLEVBQUU7Z0JBQ1YsUUFBUSxDQUFDLFlBQVksQ0FBQyxhQUFhLEVBQUUsTUFBTSxDQUFDLENBQUM7Z0JBQzdDLFFBQVEsQ0FBQyxZQUFZLENBQUMsWUFBWSxFQUFFLHNDQUFzQyxDQUFDLENBQUM7Z0JBQzVFLFFBQVEsQ0FBQyxZQUFZLENBQUMsZUFBZSxFQUFFLE1BQU0sQ0FBQyxDQUFDO2FBQ2xEO1FBQ0wsQ0FBQyxDQUFDLENBQUE7SUFFTixDQUFDLENBQUM7SUFFRixPQUFPO1FBQ0gsTUFBTSxFQUFFLElBQUk7S0FDZixDQUFDO0FBQ04sQ0FBQyxDQUFDLEVBQUUsQ0FBQztBQUdMLE9BQU8sRUFBQyxrQkFBa0IsRUFBQyxDQUFDIn0=